import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/pages/home/components/Sidebar";
import InnovationTopNav from "./InnovationTopNav";

/** 壳层与知识库页一致：白底、主区可滚动、`max-w-[1100px]` 内容列 */
export default function InnovationLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { pathname } = useLocation();

  // 记录详情页：禁用外层滚动，避免把顶部导航/标题整体卷走；滚动应只发生在详情页内部容器
  const isRecordDetail = /^\/innovation\/records\/[^/]+/.test(pathname);

  return (
    <div className="flex h-screen overflow-hidden bg-white text-foreground">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-transparent">
        {isRecordDetail ? (
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-5 py-5 md:px-6 lg:px-8">
            <div className="mx-auto flex min-h-0 w-full max-w-[1100px] flex-col gap-5">
              <InnovationTopNav />
              <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <Outlet />
              </div>
            </div>
          </div>
        ) : (
          <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5 md:px-6 lg:px-8">
            <div className="mx-auto w-full max-w-[1100px] space-y-5">
              <InnovationTopNav />
              <Outlet />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
